<template>
  <div>
    <naj-box
      :title="local.complaints.newComplaint.userInfoTab.title"
      header-icon="mdi-account"
      header-class="sub-header"
      disable-collapsing
    >
      <v-row>
        <profile-details
          :user-object="profileData"
          :is-profile="false"
          :show-modify-mobile="true"
          @onClose="loadData"
        ></profile-details>
      </v-row>
    </naj-box>
    <naj-box
      :title="local.complaints.newComplaint.userInfoTab.terms"
      header-icon="mdi-account"
      header-class="sub-header"
      disable-collapsing
    >
      <template>
        <naj-input
          :type-id="formFieldType.checkbox"
          :value.sync="complaintObj.selected"
          :label="local.complaints.newComplaint.userInfoTab.termsDescription"
          @change="onSelectionChange()"
        ></naj-input>
      </template>
    </naj-box>
    <div class="button-container">
      <naj-button
        class="left-button"
        @click="cancel()"
      >
        {{ local.common.cancel }}
      </naj-button>
      <div class="right-buttons">
        <!-- <naj-button
          type="button"
          color="#89743e"
          icon="mdi-arrow-right"
          @click="previous"
        >
          {{
            local.common.previous
          }}
        </naj-button> -->
        <naj-button
          type="button"
          append-icon
          icon="mdi-arrow-left"
          @click="next"
        >
          {{
            local.common.next
          }}
        </naj-button>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');
import ProfileDetails from '../profile/profile-details.vue';

export default {
  name: 'UserInfoTab',
  components: { ProfileDetails },
  props: {
    complaintObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      profileData: {},
      selected: false,
      isMobileVerified: false,
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapComplaintsActions([
      'getComplainantData',
    ]),
    loadData() {
      this.loading = true;
      this.getComplainantData()
        .then((data) => {
          this.profileData = data.data;
          this.complaintObj.applyComplainant = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSelectionChange() {

    },
    cancel() {
      this.$emit('cancel');
    },
    previous() { this.$route.push('/'); },
    next() {
      if (!this.complaintObj.selected) this.toaster.error(this.local.complaints.newComplaint.userInfoTab.termsErrorMessage);
      if (!this.profileData.isMobileVerfied) this.toaster.error(this.local.complaints.newComplaint.userInfoTab.verifiedMobileErrorMessage);
      if (this.complaintObj.selected && this.profileData.isMobileVerfied) this.$emit('changeTab', 'tab-2');

    },
  },
};
</script>
<style lang="scss" scoped>
.tab-header {
  height: 60px;
}
::v-deep .naj-box .naj-box-content {
  white-space: normal !important;
  overflow-wrap: break-word !important;
}
::v-deep .v-input {
  text-align: right !important;
}
::v-deep .v-input.v-input--selection-controls .v-label {
  font-weight: 700;
}
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
}
.left-button {
  margin-left: 10px;
}

.right-buttons {
  display: flex;
}
</style>
